<template lang="pug">
.analysisUser
  header
    el-select.gender(v-model="params.genders" :placeholder="$t('Analysis.User.select_gender')" size="small" multiple)
      el-option(v-for="gender in genders" :key="gender.value" :label="gender.label" :value="gender.value")
    el-select.age(v-model="params.ages" :placeholder="$t('Analysis.User.select_age')" size="small" multiple)
      el-option(v-for="age in ages" :key="age.value" :label="age.label" :value="age.value")
    el-date-picker.picker(v-model="params.daterange" type="daterange" size="small" align="right" unlink-panels
                          range-separator="〜" :start-placeholder="$t('Analysis.start_date')"
                          :end-placeholder="$t('Analysis.end_date')" :picker-options="options"
                          :value-format="'yyyy-MM-dd'")

  #graphs
    .total-graph
      h1 {{ $t('Analysis.User.title03') }}
      Total#totalGraph(:height="300" :userAccessByDay="api.userAccessByDay")
    .gender-age-graph
      h1 {{ $t('Analysis.User.title04') }}
      .graphs
        section
          p.none(v-if="checkEmpty()") {{ $t('Dashboard.none_data') }}
          Gender#genderGraph(:height="240" :userAccessByGenderAndAge="api.userAccessByGenderAndAge")
        section
          Age#ageGraph(:height="240" :userAccessByGenderAndAge="api.userAccessByGenderAndAge", :ages="params.ages", :age_settings="ages")
    .gender-rate-graph
      h1 {{ $t('Analysis.User.title05') }}
      Rate#rateGraph(:height="280", :userAccessByDay="api.userAccessByDay")
    .byage-graph
      h1 {{ $t('Analysis.User.title06') }}
      ByAge#byAgeGraph(:height="300", :userAccessByDay="api.userAccessByDay")

    UserList(:ages="params.ages", :genders="params.genders", :daterange="params.daterange")

</template>

<script>
import Total from './TotalUser'
import Gender from './Gender'
import Age from './Age'
import Rate from './Rate'
import ByAge from './ByAge'
import UserList from './UserList'
import API from '@/api/analytics'
import { mapState } from 'vuex';
export default {
  components: { Total, Gender, Age, Rate, ByAge, UserList },
  data() {
    return {
      beforeMount: false,
      genderLoading: null,
      ageLoading: null,
      rateLoading: null,
      byageLoading: null,
      params: {
        genders: [],
        ages: [],
        daterange: []
      },
      genders: [{
        label: this.$t('Analysis.User.male'),
        value: 'male'
      },{
        label: this.$t('Analysis.User.female'),
        value: 'female'
      },{
        label: this.$t('Analysis.User.other'),
        value: 'other'
      }],
      ages: [{
        label: this.$t('Analysis.User.age10'),
        value: 'from10to19'
      },{
        label: this.$t('Analysis.User.age20'),
        value: 'from20to29'
      },{
        label: this.$t('Analysis.User.age30'),
        value: 'from30to39'
      },{
        label: this.$t('Analysis.User.age40'),
        value: 'from40to49'
      },{
        label: this.$t('Analysis.User.age50'),
        value: 'from50to59'
      },{
        label: this.$t('Analysis.User.age60'),
        value: 'from60to69'
      },{
        label: this.$t('Analysis.User.age70'),
        value: 'over70'
      },{
        label: this.$t('Analysis.User.ageOther'),
        value: 'other'
      }],
      options: {
        shortcuts: [{
          text: this.$t('Analysis.last_week'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('Analysis.last_month'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: this.$t('Analysis.past_3month'),
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      api: {
        userAccessByDay: { },
        userAccessByGenderAndAge: { }
      }
    }
  },
  beforeMount() {
    this.beforeMount = true;
    this.params = this.analysisFilters;
  },
  mounted() {
    this.$nextTick(function () {
      this.beforeMount = false;
      this.updateChartData();
    })
  },
  methods: {

    // 部分ローディングを生成
    makeLoading: function(name){
      return this.$loading({
        target: document.getElementById(name),
        fullscreen: false,
        background: 'rgba(255, 255, 255, 0.8)'
      })
    },
    // 男女年齢比率を取得
    getUserAnalysis: function (date = null){
      return this.$store.dispatch('getUserAnalysis', date)
        .then(() => {
          this.genderLoading.close();
          this.ageLoading.close()
        }).catch((e) => {
        })
    },
    updateChartData: function() {
      if(this.beforeMount) return;
      this.$store.commit('setAnalysisFilters', this.params);
      const obj = this;
      const reqParams = {
        daterange: this.params.daterange,
        ages: this.params.ages,
        genders: this.params.genders
      };
      API.getCustomerAccessByDay(reqParams).then(function(response) {
        if (response && response.access_data) {
          obj.api.userAccessByDay = response.access_data;
        } else {
          obj.api.userAccessByDay = { };
        }
      });
      API.getCustomerAccessByGenderAndAge(reqParams).then(function(response) {
        if (response && response.customer_counts_by_gender_and_age) {
          obj.api.userAccessByGenderAndAge = response.customer_counts_by_gender_and_age;
        } else {
          obj.api.userAccessByGenderAndAge = { };
        }
      });
    },
    checkEmpty: function()
    {
      return Object.values(this.api.userAccessByDay).every(v => Object.keys(v).length === 0)
    }
  },
  title() {
    return this.$t('menus.user')
  },
  computed: {
    ...mapState({
      analysisFilters: state => state.analysis.analysisFilters
    })
  },
  watch : {
    params: {
      handler: function() {
        this.updateChartData();
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables.scss";

.analysisUser {
  padding-top: 80px;

  header {
    position: fixed;
    z-index: 100;
    width: calc(100vw - 320px);
    margin-top: -80px;
    background: #FEFEFE;
    padding: 15px 40px;
    border-bottom: 1px solid $border;

    .gender, .age {
      width: 240px;
      margin: 0 20px 0 0;
    }
    .picker {
      width: 280px;
      float: right;
    }
  }

  #graphs {
    background: #FFF;
    margin: 20px 40px;
    border: 1px solid $border;
    border-radius: 5px;
    padding-bottom: 40px;

    .total-graph,
    .gender-age-graph,
    .gender-rate-graph,
    .byage-graph {
      padding: 30px 40px;

      h1 {
        display: block;
        padding: 0;
        margin: 0 0 20px 0;
        font-size: 16px;
        font-weight: normal;
      }
    }

    .graphs {
      display: flex;
      align-content: space-between;
      section {
        width: 50%;
        display: flex;
      }
      p.none {
        position: absolute;
        color: #999;
        font-size: 12px;
        margin: 95px 0 0 110px;
      }
    }
  }
}

</style>

